import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuthSession } from './AuthSessionProvider';
import { useSettingsQuery } from '../../features/settings/api/queries';
import {
  DEFAULT_CURRENCY_CONFIG,
  setCurrentCurrencyConfig,
} from '../../shared/utils/currencyConfig';

const BASE_PUBLIC_PATH_PREFIXES = [
  '/landing',
  '/login',
  '/auth/clerk/sign-in',
  '/accept-invitation',
  '/request-portal',
  '/sample-portal',
  '/customer-portal',
  '/admin',
];

function shouldHydrateCurrencySettings(pathname = '') {
  if (!pathname || pathname === '/') {
    return false;
  }

  return !BASE_PUBLIC_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
}

export default function CurrencySettingsProvider({ children }) {
  const location = useLocation();
  const { session } = useAuthSession();
  const canHydrate = Boolean(session?.tenantId) && shouldHydrateCurrencySettings(location.pathname);
  const settingsQuery = useSettingsQuery({ enabled: canHydrate });

  useEffect(() => {
    if (!canHydrate) {
      setCurrentCurrencyConfig(DEFAULT_CURRENCY_CONFIG);
      return;
    }

    setCurrentCurrencyConfig(settingsQuery.data || DEFAULT_CURRENCY_CONFIG);
  }, [canHydrate, settingsQuery.data]);

  return children;
}
